import { Injectable } from '@angular/core';
import { Action } from '../model/action';
import { PromotionCode } from '../model/promotion-code';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { HttpClientService } from '../../../shared/service/http/http-client.service';
import { CookiesService } from '../../../shared/service/cookies/cookies.service';
@Injectable()
export class PromotionCodeService {

  http:HttpClientService;
  cookie : CookiesService;
  objAction : Action;
  data : PromotionCode;
  constructor(http : HttpClientService, cook : CookiesService) {
     this.http = http;
     this.cookie = cook;
     this.objAction  = new Action(this.http,  this.cookie);
  }
  savePromotionCode() : Observable<PromotionCode> {   
     this.objAction.header = null;
     this.objAction.data = this.data;
     this.objAction.path = 'api/PromotionCode/CreatePromotionCode';
     return this.objAction.save();
  }
   getPromotionCode(userId: number):   Observable<PromotionCode[]> {
     this.objAction.path = 'api/PromotionCode/GetPromotionCode/' + userId;
    return this.objAction.get();
  }
  updatePromotionCode() : Observable<PromotionCode> {   
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path = 'api/PromotionCode/UpdatePromotionCode'
    return this.objAction.update();
  }
  deletePromotionCode(org: any): Observable<PromotionCode> {
    console.log('org', org);
    console.log('org.Id', org.Id);
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path = 'api/PromotionCode/DeletePromotionCode?strPromotionCodeId=' + org.Id;
    return this.objAction.delete();
 }

}



// WEBPACK FOOTER //
// ./src/app/section/master/services/promotion-code.service.ts